// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchCriteriaAction.js" company="Izenda">  Copyright (c) 2015
// Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var compose = require('recompose').compose;
  var withHandlers = require('recompose').withHandlers;
  var lifecycle = require('recompose').lifecycle;
  var observe = require('mobx').observe;
  var uiState = require('logic/Izenda.UiState');
  var compareDateStringFormat = require('share/utils/Izenda.DateTimeUtils').compareDateStringFormat;
  var VALIDATE_DATE_MESSAGE = require('logic/data/Izenda.SchedulingSearchConstants').VALIDATE_DATE_MESSAGE;
  const { curry, last, isEmpty, filter, map, get, findIndex } = require('lodash/fp');

  var SearchCriteriaAction = compose(
    withHandlers({
      handleChangeMultiValuesCriteria: curry(handleChangeMultiValuesCriteria),
      handleChangeCriteria: curry(handleChangeCriteria),
      handleChangeDeliveryType: curry(handleChangeDeliveryType),
      handleAddNewReportName: curry(handleAddNewReportName),
      handleSearch: curry(handleSearch),
      resetData: curry(resetData),
      validateLastSuccessfulRunDate: curry(validateLastSuccessfulRunDate),
      validateNextScheduledRunDate: curry(validateNextScheduledRunDate)
    }),
    lifecycle({
      componentDidMount: function() {
        var props = this.props;
        var store = props.store;
        initData(props);
        this.disposeObserveTenantID = observe(uiState, 'tenantId', function() {
          store.resetData();
          initData(props);
        });
      },
      componentWillUnmount: function() {
        this.disposeObserveTenantID();
      }
    })
  );

  /**
   * Init search criteria data
   * @param props
   */
  function initData(props) {
    var store = props.store;
    var loader = props.loader;
    loader.startLoading();
    Promise.join(
      store.loadEmailTemplates(),
      store.loadReportDashboardName(),
      store.loadCreatorByTenant(),
      store.loadRecipientsByTenant()
    ).finally(loader.endLoading.bind(loader));
  }

  /**
   * Handle Change Multivalues Criteria
   * If "All" selected, other criteria is automatically removed
   * If not "All" selected, "All" criteria is removed
   * @param props
   * @param key
   * @param options
   */
  function handleChangeMultiValuesCriteria(props, key, options) {
    if (options.length === 0) {
      options = [
        {
          value: '',
          label: 'All'
        }
      ];
    }
    var lastOption = last(options);
    if (isEmpty(lastOption.value)) {
      options = [lastOption];
    } else {
      options = filter(function(item) {
        return !!item.value;
      }, options);
    }
    options = map(get('value'), options).join(';');
    props.store.criteria.setValueByKey(key, options);
  }

  /**
   * Change Single criteria
   * @param props
   * @param key
   * @param value
   */
  function handleChangeCriteria(props, key, value) {
    props.store.criteria.setValueByKey(key, value);
  }

  /**
   * Set delivery type, reset delivery method
   * @param props
   * @param key
   * @param value
   */
  function handleChangeDeliveryType(props, key, value) {
    handleChangeMultiValuesCriteria(props, key, value);
    props.store.criteria.setValueByKey('deliveryMethod', '');
  }

  /**
   * Add a user specified Report Name to reportDashboardNames's option data
   * @param props
   * @param newData
   */
  function handleAddNewReportName(props, newData) {
    if (isEmpty(newData.value.trim())) {
      return;
    }
    var reportDashboardNameOptions = props.store.criteria.reportDashboardNameOptions;
    var index = findIndex({ value: newData.value }, reportDashboardNameOptions);
    index === -1 &&
      props.store.criteria.reportDashboardNameOptions.push({
        label: newData.label,
        value: newData.value,
        isNew: newData.isNew
      });
  }

  /**
   * Handle searching
   * Put the calling to db into window.setTimeout() to make it run after other control fire onBlur event
   * @param props
   */
  function handleSearch(props, _) {
    window.setTimeout(function() {
      var loader = props.loader;
      loader.startLoading();
      props.store.loadSchedules().finally(loader.endLoading.bind(loader));
    }, 0);
  }

  /**
   * Reset the page back to it's first launched state
   * @param props
   */
  function resetData(props, _) {
    props.store.resetData();
  }

  function validateLastSuccessfulRunDate(props, _) {
    validateDate(props, 'lastSuccessfulRunFrom', 'lastSuccessfulRunTo');
  }

  function validateNextScheduledRunDate(props, _) {
    validateDate(props, 'nextScheduledRunFrom', 'nextScheduledRunTo');
  }

  function validateDate(props, from, to) {
    var valManager = props.validation;
    var criteria = props.store.criteria;
    valManager.reset();
    if (compareDateStringFormat(criteria[from], criteria[to])) {
      valManager.updateErrors(constructValidateMessage([from, to]));
    }
  }

  function constructValidateMessage(keys) {
    return keys.map(function(key) {
      return {
        key: key,
        messages: [VALIDATE_DATE_MESSAGE]
      };
    });
  }

  module.exports = SearchCriteriaAction;
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/Scheduling/Izenda.SearchCriteriaAction.js